import { useCallback } from 'react'

import Whoami from 'actions/whoami-react'
import { useProfileState } from 'context/profile'

export default function useWhoami(contract) {
    const { profile  } = useProfileState()
    const getWhoamiFor = useCallback((contract) => {
        return new Whoami(contract, profile.email, profile._id, profile.roles, profile.organization);
    }, [profile.email, profile._id, profile.roles, profile.organization])

    return { whoami: contract ? getWhoamiFor(contract) : undefined, getWhoamiFor };  
}